import { useEffect, useState } from "react";
import styles from "./AccountInfo.module.css";
import Button from "./Button";
import { Link } from "react-router-dom";
import { getUserProfiles, UpdateUserProfiles } from "services/api";
import Spinner from "./Spinner";

const AccountInfo = () => {
  const [profile, setProfile] = useState({});
  const [Errors, setErrors] = useState({});
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(true);


  const getProfile = async () => {
    setLoading(true);
    const data = await getUserProfiles();

    if (!data.phone) {
      data.phone = "";
    }

    setProfile(data);
    setLoading(false);
  }


  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    console.log("updating profile", profile);
    const data = await UpdateUserProfiles(profile);
    if (!data.success && data.errors) {
      console.log("Update failed", data.errors);

      setErrors(data.errors.errors || {});
    } else {
      setErrors({});
      setAlert({ type: 'success', message: "Vos informations ont été mises à jour avec succès." });
      setTimeout(() => {
        setAlert(null);
      }, 5000);
      console.log("Profile updated successfully", data);
    }
  }

  useEffect(() => {
    console.log("getting profile");
    getProfile();
  }, []);

  return (
    <div className={styles.AccountInfo}>
      <div className={styles.formContainer}>
        {loading && (
          <Spinner />
        )}
        {
          !loading && profile && <>
            <div className={styles.Title}>Bienvenue sur votre espace, {profile.firstname}</div>
            <p className={styles.Description}>Vous trouverez vos coordonnées ci-dessous.</p>
            <form onSubmit={handleUpdateProfile}>
              {alert && (
                <div className={`${styles.alert} ${styles[alert?.type]}`}>
                  {alert?.message}
                </div>
              )}
              <ul className={styles.InputsList}>
                <li>
                  <label htmlFor="username">Email (identifiant)*</label>
                  <input
                    type="text"
                    id="username"
                    defaultValue={profile.email || ""}
                    name="username"
                    onChange={e => {
                      setProfile({ ...profile, email: e.target.value })
                    }}
                  />
                  {Errors.email && <span className={styles.error}>{Errors.email}</span>}
                </li>
                <li>
                  <label htmlFor="username">Mot de passe*
                  </label>
                  <input
                    id="password"
                    name="password"
                    type="password"
                    onChange={e => {
                      setProfile({ ...profile, password: e.target.value })
                    }}
                  />
                  {Errors.password && <span className={styles.error}>{Errors.password}</span>}
                </li>
                <li>
                  <label htmlFor="confirm-password">Confirmer mot de passe*
                  </label>
                  <input
                    id="confirm-password"
                    name="confirm-password"
                    type="password"
                    onChange={e => {
                      setProfile({ ...profile, confirmPassword: e.target.value })
                    }}
                  />
                  {Errors.confirmPassword && <span className={styles.error}>{Errors.confirmPassword}</span>}
                </li>
                <li className={styles.rowSplit}>
                  <label htmlFor="firstname">Prénom*
                  </label>
                  <input
                    type="text"
                    defaultValue={profile.firstname || ""}
                    id="firstname"
                    name="firstname"
                    onChange={e => {
                      setProfile({ ...profile, firstname: e.target.value })
                    }}
                  />
                  {Errors.firstname && <span className={styles.error}>{Errors.firstname}</span>}
                </li>
                <li className={styles.rowSplit}>
                  <label htmlFor="lastname">Nom*
                  </label>
                  <input
                    type="text"
                    id="lastname"
                    name="lastname"
                    defaultValue={profile.lastname || ""}
                    onChange={e => {
                      setProfile({ ...profile, lastname: e.target.value })
                    }}
                  />
                  {Errors.lastname && <span className={styles.error}>{Errors.lastname}</span>}
                </li>
                <li>
                  <label htmlFor="phone">Téléphone*
                  </label>
                  <input
                    type="text"
                    id="phone"
                    name="phone"
                    defaultValue={profile.phone || ""}
                    onChange={e => {
                      setProfile({ ...profile, phone: e.target.value })
                    }}
                  />
                  {Errors.phone && <span className={styles.error}>{Errors.phone}</span>}
                </li>
              </ul>

              <Button type="submit">Mettre à jour mes informations</Button>
            </form>
          </>
        }
      </div>
    </div>
  );
}

export default AccountInfo;
